import React from 'react';
import Column from '../../shared/ui/Column';
import CompaniesList from '../../controllers/CompanieslList';
import ModelSearch from '../../controllers/ModelSearch';
import { selectors, actionCreators, sliceKeys } from '../../model';

const { selectSearch } = selectors[sliceKeys.companies];
const { searchChanged } = actionCreators[sliceKeys.companies];

const CompaniesCol = () => {
  return (
    <Column title="Компании">
      <CompaniesList>
        <ModelSearch selector={selectSearch} createAction={searchChanged} />
      </CompaniesList>
    </Column>
  );
};

export default CompaniesCol;
